(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[384],{

/***/ 10384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content022": function() { return /* binding */ Content022; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14258);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32667);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88494);
/* harmony import */ var _Content022_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25398);
/* harmony import */ var _Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var Content022 = function(param) {
    var payload = param.payload;
    var ref;
    var slider = (ref = payload === null || payload === void 0 ? void 0 : payload.slider) !== null && ref !== void 0 ? ref : {};
    var ref1;
    var sliderSize = (ref1 = payload === null || payload === void 0 ? void 0 : payload.sliderSize) !== null && ref1 !== void 0 ? ref1 : "large";
    var ref2;
    var backgroundColor = (ref2 = payload === null || payload === void 0 ? void 0 : payload.backgroundColor) !== null && ref2 !== void 0 ? ref2 : "light";
    var ref3;
    var backgroundPosition = (ref3 = payload === null || payload === void 0 ? void 0 : payload.backgroundPosition) !== null && ref3 !== void 0 ? ref3 : "top";
    var ref4 = (0,shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_5__/* .useViewMode */ .mJ)(), isMobile = ref4.isMobile, isDesktop = ref4.isDesktop;
    var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var nextRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrapper),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default())["".concat(backgroundColor)], (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default())["".concat(backgroundPosition)])
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inner), sliderSize === "large")),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slider),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .SwiperLayout */ .OJ, {
                                prevRef: prevRef,
                                nextRef: nextRef,
                                watchOverflow: false,
                                slidesPerView: 1,
                                slidesPerGroup: 1,
                                loop: true,
                                paginationWrapper: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pagination),
                                children: slider.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                        className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slide),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .ImageLite */ .NH, {
                                                image: item.image,
                                                className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().image)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_2__/* .RichText */ .H, {
                                                color: isMobile ? "dark" : "light",
                                                className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().description),
                                                value: item.description
                                            })
                                        ]
                                    }, item.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["navigation-wrapper"]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["slider-navigation"]),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            ref: prevRef,
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().navigation), (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["navigation-prev"])),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                                className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon),
                                                name: "arrow_slider_prev"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            ref: nextRef,
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().navigation), (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["navigation-next"])),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                                className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon),
                                                name: "arrow_slider_next"
                                            })
                                        })
                                    ]
                                }),
                                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Content022_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pagination)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content022);


/***/ }),

/***/ 25398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content022_wrapper__Aifwe","top":"Content022_top__MZrZa","bottom":"Content022_bottom__4h2CI","light":"Content022_light__Bu0K0","grey":"Content022_grey__alyGh","dark":"Content022_dark__T3HT_","inner":"Content022_inner__Whnpp","content":"Content022_content__fUwrq","slider":"Content022_slider__7SfQ_","slide":"Content022_slide__WoiFr","description":"Content022_description__qFVnq","image":"Content022_image__eo6ro","navigation-wrapper":"Content022_navigation-wrapper__mbPLE","pagination":"Content022_pagination__1XPYF","slider-navigation":"Content022_slider-navigation__9z0V8","navigation":"Content022_navigation__T3CxW","navigation-prev":"Content022_navigation-prev__vmCfM","navigation-next":"Content022_navigation-next__mPQqx"};

/***/ })

}]);